<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-boxes-stacked"></i></span>{{ "StockMaintenance.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [(selected)]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="grid formgrid p-fluid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.brand' | translate }}</label>
              <p-dropdown formControlName="brand"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                          [options]="brandOptions"
                          [filter]="true"
                          [virtualScroll]="true"
                          [itemSize]="10"
                          filterBy="label">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.internalBrand' | translate }}</label>
              <p-dropdown formControlName="internalBrand"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                          [options]="internalBrandOptions"
                          [filter]="true"
                          [virtualScroll]="true"
                          [itemSize]="10"
                          filterBy="label">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.facility' | translate }}</label>
              <laas-facility-dropdown
                formControlName="facility"
                [isSingle]="true">
              </laas-facility-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.storer' | translate }}</label>
              <input type="text" pInputText formControlName="storer" />
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.orgId' | translate }}</label>
              <p-dropdown
                #dd
                formControlName="orgId"
                optionLabel="label"
                optionValue="value"
                [options]="orgIdOptions"
                [filter]="true"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.uId' | translate }}</label>
              <input type="text" pInputText formControlName="uId" />
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.caseId' | translate }}</label>
              <input type="text" pInputText formControlName="caseId" />
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.sku' | translate }}</label>
              <input type="text" pInputText formControlName="sku" />
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.uidLockCode' | translate }}</label>
              <input type="text" pInputText formControlName="reservedConsigneeKey" />
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'StockMaintenance.MainTable.Column.originalAD' | translate }}</label>
              <input type="text" pInputText formControlName="originReceiptKey" />
            </div>

            <div class="field col-12 lg:col-9">
              <div>
                {{ "StockMaintenance.MainTable.Column.dateCode" | translate }}
              </div>
              <div class="formgrid grid">
                <div class="col-4">
                  <div class="flex flex-wrap align-items-center">
                    <div class="flex-initial">
                      <p-radioButton
                        formControlName="dateCodeType"
                        value="1"
                        (click)="dateCodeType1()"
                      ></p-radioButton>
                    </div>
                    <div class="flex-1 ml-1">
                      <p-inputNumber
                        formControlName="dateCode"
                        [maxlength]="6"
                        [min]="100000"
                        [max]="999999"
                        [format]="false"
                        [placeholder]="'yyyyWW'"
                      ></p-inputNumber>
                    </div>
                  </div>
                </div>
                <div class="col-8">
                  <div class="flex flex-wrap align-items-center">
                    <div class="flex-initial">
                      <p-radioButton
                        formControlName="dateCodeType"
                        value="2"
                        (click)="dateCodeType2()"
                      ></p-radioButton>
                    </div>
                    <div class="flex-1 ml-1">
                      <p-inputNumber
                        formControlName="dateCodeWWStart"
                        [maxlength]="3"
                        [min]="0"
                        [max]="999"
                        [format]="false"
                        [placeholder]="'WW | WWW'"
                      ></p-inputNumber>
                    </div>

                    <div class="flex-initial">
                      <span>&nbsp;~&nbsp;</span>
                    </div>
                    <div class="flex-1">
                      <p-inputNumber
                        formControlName="dateCodeWWEnd"
                        [maxlength]="3"
                        [min]="0"
                        [max]="999"
                        [format]="false"
                        [placeholder]="'WW | WWW'"
                      ></p-inputNumber>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                  #destockingDate
                  [title]="'StockMaintenance.MainTable.Column.destockingDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'destockingDate')">
              </laas-calendar>
            </div>

            <div class="field col-12">
              <small><strong class="p-invalid">
                {{ 'StockMaintenance.Message.NotificationOfQuery' | translate }}
              </strong></small>
            </div>

          </div>
          <div>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Search' | translate }}"
              (click)="searchBtnClick($event)"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Reset' | translate }}"
              type="reset"
              class="p-button-secondary ml-2"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Import' | translate }}"
              (click)="visibleChangeOfStockDataImportModal(true)"
              class="ml-4">
            </button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Export' | translate }}"
              (click)="exportBtnClick($event)"
              class="ml-2">
            </button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <p-table
        #stockTable
        [columns]="selectedColumns"
        [value]="tableValue"
        [scrollable]="true"
        scrollHeight="500px"
        [reorderableColumns]="true"
        [resizableColumns]="true"
        [totalRecords]="this.pageInfo.totalRecords"
        (onPage)="this.tablePageChange($event)"
        (onSort)="this.tableSort($event)"
        [rowsPerPageOptions]="[5, 10, 25, 50, 100]"
        [showCurrentPageReport]="true"
        [paginator]="true"
        [rows]="5"
        [loading]="isSearching"
        [lazy]="true"
        currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
        selectionMode="single"
        [(selection)]="selectRow"
        class="edittable"
        dataKey="rowId"
        editMode="row"
        styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
      >
        <ng-template pTemplate="caption">
          <div class="flex align-items-center">
            <laas-table-column-toggle
              [optionsColumn]="tableColumns"
              [dataTable]="stockTable"
            >
            </laas-table-column-toggle>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Save' | translate}}"
              icon="fas fa-save"
              [disabled]="!isEditMode"
              (click)="saveBtnClick()"
              class="p-button-raised ml-2"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Restore' | translate }}"
              icon="fas fa-sync-alt"
              [disabled]="!isEditMode"
              (click)="resetTableValue()"
              class="p-button-secondary p-button-raised ml-2"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.ViewOrEdit' | translate }}"
              icon="fas fa-pen"
              (click)="switchEditMode()"
              class="p-button-warning p-button-raised ml-2"
              style="color: white"
            ></button>
          </div>
        </ng-template>

        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" style="width: 14.8vw" />
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              scope="col"
              pResizableColumn
              pReorderableColumn
              *ngFor="let col of columns"
              [attr.field]="col.field"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              [style]="{ width: col.width + 'px' }"
            >
              {{ col.header | translate }}
              <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-columns="columns"
          let-rowData
        >
          <tr [pSelectableRow]="rowData" [pEditableRow]="rowData">
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'facility'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: facilityOptions | replaceNullWith: '-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'reservedOrgId'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: orgIdOptions | replaceNullWith: '-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: orgIdOptions | replaceNullWith: '-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'brand'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: brandOptions | replaceNullWith: '-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'receivedTime'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date: 'yyyy/MM/dd HH:mm:ss': this.laasSetting.facilityTimeZone | replaceNullWith: '-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'lastUpdateDate'" class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date: 'yyyy/MM/dd HH:mm:ss': this.laasSetting.facilityTimeZone | replaceNullWith: '-' }}
                  </div>
                </ng-container>

                <p-cellEditor *ngSwitchCase="'trackingItemsNotes'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <div class="overflow-text field">
                      <input
                        pInputText
                        type="text"
                        [(ngModel)]="rowData[col.field]"
                        #val ="ngModel"
                      />
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: '-' }}
                    </div>
                  </ng-template>
                </p-cellEditor>

                <p-cellEditor *ngSwitchCase="'destockingDate'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <div class="overflow-text field">
                      <p-calendar
                        appendTo="body"
                        dataType="date"
                        dateFormat="yy/mm/dd"
                        [required]="true"
                        (ngModelChange)="changeTrackingDate($event, rowData)"
                        [ngModel]="rowData[col.field] | date: 'yyyy/MM/dd': this.laasSetting.facilityTimeZone"
                      ></p-calendar>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date: 'yyyy/MM/dd': this.laasSetting.facilityTimeZone | replaceNullWith: '-' }}
                    </div>
                  </ng-template>
                </p-cellEditor>

                <ng-container *ngSwitchDefault class="p-fluid">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-' }}
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="tableColumns.length + 1">
              {{ "Common.Table.NoData" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-card>
  <ng-container *ngIf="isShowImportStockDataModal">
    <laas-stock-maintenance-import
      [(visible)]="isShowImportStockDataModal"
      (visibleChange)="visibleChangeOfStockDataImportModal($event)"
    ></laas-stock-maintenance-import>
  </ng-container>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
